import type { RequestParams } from '@/shared/api';

export const STAFF_KEYS = {
  all: ['staff'] as const,
  list: (params?: RequestParams) => [...STAFF_KEYS.all, 'list', params] as const,
  detail: (id: number | string) => [...STAFF_KEYS.all, 'detail', id] as const,
};
